<svelte:options customElement="landing-dropdown" />

<script>
    import { Theme, Button } from "@urbaninstitute/dataviz-components";
    import Dropdown from "./Dropdown/Dropdown.svelte";
    import state_urls from "../data/state_urls.json";

    const dropdownData = state_urls.map((d) => ({
        label: d.state_name,
        value: d.state_url,
        disabled: d.disabled,
    })).sort  ((a, b) => a.label.localeCompare(b.label));

    /** @type { string } */
    let selectedUrl = dropdownData[0].value;

    function goToState() {
        window.location.href = selectedUrl;
    }
</script>

<Theme>
    <div class="wrapper">
        <Dropdown
            id="dropdown"
            data={dropdownData}
            inlineLabel="Dropdown"
            bind:value={selectedUrl}
            placeholder={null}
        />
        <Button size="small" on:click={goToState}>View</Button>
    </div>
</Theme>

<style>
    .wrapper {
        display: flex;
        gap: 1.5rem;
    }
</style>
